<div fxLayout="row" class="background">
  <div fxFlex="80" fxFlexOffset="10%">

    <section id="header">
      <h1 class="h1Header">ADMINISTRAR CATEGORÍAS</h1>
    </section>

    <section id="table">
      <mat-card class="mat-elevation-z0">
        <div>
          <button mat-flat-button class="add-btn" (click)="addCategory()">Agregar nueva</button>
        </div>

        <table mat-table [dataSource]="allItems" class="mat-elevation-z0">

          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef class="table-header">Id</th>
            <td mat-cell *matCellDef="let category"> {{category.cdItemsCategory}} </td>
          </ng-container>


          <ng-container matColumnDef="order">
            <th mat-header-cell *matHeaderCellDef class="table-header">ORDEN</th>
            <td mat-cell *matCellDef="let category"> {{category.nmOrder}} </td>
          </ng-container>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef class="table-header">NOMBRE</th>
            <td mat-cell *matCellDef="let category"> {{category.dsTitle}} </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef class="table-header">ESTADO</th>
            <td mat-cell *matCellDef="let category">
              <p [style.color]="category.isEnabled ? 'blue' : '#F44336'">{{category.isEnabled | status}}</p>
              <button mat-flat-button (click)="changeCategoryStatus(category.cdItemsCategory, category.isEnabled)"
                      [ngClass]="{'activate-btn': !category.isEnabled, 'deactivate-btn': category.isEnabled}">
                {{category.isEnabled | changeStatus}}
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="option">
            <th mat-header-cell *matHeaderCellDef class="table-header">OPCIONES</th>
            <td mat-cell *matCellDef="let category">
              <button mat-mini-fab class="edit-btn" (click)="editCategory(category.cdItemsCategory)"
                matTooltip="Editar categoría"><mat-icon>create</mat-icon>
              </button>
              <button mat-mini-fab class="delete-btn" (click)="deleteCategory(category.cdItemsCategory)"
              matTooltip="Eliminar categoría"><mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

      </mat-card>
    </section>
  </div>
</div>
